export default __webpack_public_path__ + "c327c731ddf482eb53b11eaabe68a71b.png";